import Injector from 'vue-inject';
import Vue from 'vue';
import * as VueGoogleMaps from 'vue2-google-maps';
import { GOOGLE_MAPS_KEY } from '@/util/constants';

export default class GoogleMapsService {
  constructor(publicConfigService) {
    this.publicConfigService = publicConfigService;
    this.initializePromise = null;
  }

  initialize() {
    if (this.initializePromise) {
      return this.initializePromise.then();
    }

    return this.initializePromise = this.publicConfigService.getConfig()
      .then(config => config.maps_key || GOOGLE_MAPS_KEY)
      .then(key => {
        Vue.use(VueGoogleMaps, {
          load: {
            key,
            libraries: 'places',
          },
        });
        return VueGoogleMaps.loaded;
      });
  }
}

Injector.service('googleMapsService', ['publicConfigService'], GoogleMapsService);



// WEBPACK FOOTER //
// ./src/services/GoogleMapsService.js